import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
    
@Injectable({
  providedIn: 'root'  // This makes it globally available
})
export class AccountWithdrawService{

    constructor(private http: HttpClient){}

      initiateWithdrawApproval(token: string) {
    // Create the JSON object
    const payload = { accessToken: token };

    // Make the POST request with JSON payload
    return this.http.post(
      `${environment.apiUrl}/public/initiate_withdraw_cash_transfer_with_link`,
      payload,  // The body of the request
      {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' })
      }
    );
  }
  initiate_add_cash_transfer_with_link(payload: any) {
    // Make the POST request with JSON payload
    return this.http.post(
      `${environment.apiUrl}/public/initiate_add_cash_transfer_with_link`,
      payload,  // The body of the request
      {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' })
      }
    );
  }
  get_transfer_type_by_transfer_id(token: string) {
    // Create the JSON object
    const payload = { accessToken: token };

    // Make the POST request with JSON payload
    return this.http.post(
      `${environment.apiUrl}/public/get_transfer_type_by_transfer_id`,
      payload,  // The body of the request
      {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' })
      }
    );
  }
  /** Fetches the transfer's own detail record (server decrypts the access token into the real
   *  TransferID) so the txnApproval page can show it before the client decides to Continue/Cancel. */
  get_cash_transfer_details_by_transfer_id(token: string) {
    const payload = { accessToken: token };

    return this.http.post(
      `${environment.apiUrl}/public/get_cash_transfer_details_by_transfer_id`,
      payload,
      {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' })
      }
    );
  }
}